/**
 * Swiper 10.2.0
 * @url : https://swiperjs.com/api/
 *
 * Residences slider & his version with filters
 * To display only a selected amount of residences
 */
// import Swiper JS
// core version + navigation, pagination & keyboard modules:
import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard } from 'swiper/modules';

export function lodgingGallery() {
  // Swiper instance
  const lodgingGallerySlider = new Swiper('.js-lodging-gallery', {
    modules: [Navigation, Pagination, Keyboard],
    grabCursor: true,
    slidesPerView: 'auto',
    speed: 700,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el:  '.swiper-pagination',
      clickable: true
    },
    keyboard: true,
  })
}
